import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=07b8838f&scoped=true&"
import script from "./DocumentDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentDetails.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetails.vue?vue&type=style&index=0&id=07b8838f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8838f",
  null
  
)

export default component.exports